export const SOLUTION_TO_CANONICAL_URL_MAPPING = {
    "113127": "https://monday.com/templates/content-planning"
};
export const getSolutionThumbnail = (solutionData)=>{
    var _solutionData_images_;
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.thumbnailUrl) || (solutionData === null || solutionData === void 0 ? void 0 : solutionData.images) && (solutionData === null || solutionData === void 0 ? void 0 : (_solutionData_images_ = solutionData.images[0]) === null || _solutionData_images_ === void 0 ? void 0 : _solutionData_images_.url);
};
export const getSolutionName = (solutionData)=>{
    return solutionData === null || solutionData === void 0 ? void 0 : solutionData.name;
};
export const getSolutionDescription = (solutionData)=>{
    return solutionData === null || solutionData === void 0 ? void 0 : solutionData.description;
};
export const getSolutionShortDescription = (solutionData)=>{
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.shortDescription) || (solutionData === null || solutionData === void 0 ? void 0 : solutionData.description);
};
export const getSolutionEnglishName = (solution)=>{
    //Takes the not translated solution name not from the solution data
    return (solution === null || solution === void 0 ? void 0 : solution.name) || getSolutionName(solution === null || solution === void 0 ? void 0 : solution.data);
};
export const getSolutionId = (solution)=>{
    // using app_feature_reference_id since it doesn't change and id can change with new versions
    return (solution === null || solution === void 0 ? void 0 : solution.app_feature_reference_id) || (solution === null || solution === void 0 ? void 0 : solution.id);
};
export const getSolutionCategoryIds = (solutionData)=>{
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.categories) || [];
};
